// src/socket.js
import { io } from "socket.io-client";

/**
 * 🔥 IMPORTANT:
 * Socket.IO must connect to ROOT domain
 * NOT /api
 */
const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "https://vartasocial.com";

export const socket = io(SOCKET_URL, {
  path: "/socket.io",
  transports: ["websocket", "polling"],
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000
});

/* Connect ONCE, token attached */
let connectedOnce = false;

export function connectSocketOnce() {
  if (connectedOnce) return;

  socket.auth = {
    token: localStorage.getItem("token"),
  };

  socket.connect();
  connectedOnce = true;
}

/* Debug */
socket.on("connect", () => {
  console.log("🟢 SOCKET CONNECTED:", socket.id);
});

socket.on("connect_error", (err) => {
  console.error("❌ SOCKET CONNECT ERROR:", err.message);
});